import axios from "axios";
import { store } from "@src/redux/store";
import { setMaintenance } from "@src/redux/maintenance";
import { getBaseUrl } from "./helpers";

const HEALTH_CHECK_TIMEOUT = 10000; // ms

let confirming = null;

// Probes the bare API root: it has no route (404 while up) but still passes
// Laravel's maintenance middleware (503 during `php artisan down`). `/up` can't
// be used — Laravel 12 exempts the health route from maintenance mode.
// Plain fetch on purpose — no auth, no interceptors.
export const isBackendUp = () =>
  fetch(`${getBaseUrl()}/api`, { cache: "no-store", signal: AbortSignal.timeout?.(HEALTH_CHECK_TIMEOUT) })
    .then((response) => response.status !== 503)
    .catch(() => false);

// A 503 flagged `maintenance: true` is the maintenance mode set by the app-status commands — switch at once.
// Any other 503, or a request that never got a response, may mean the backend is
// down or just a network blip — one health check confirms it before switching.
export const flagMaintenanceIfDown = (error) => {
  if (store.getState().maintenance?.isOn) {
    return;
  }

  if (error?.response?.status === 503 && error.response.data?.maintenance === true) {
    store.dispatch(setMaintenance(true));
    return;
  }

  const suspicious = error?.response ? error.response.status === 503 : !axios.isCancel(error);

  if (!suspicious || confirming) {
    return;
  }

  confirming = isBackendUp()
    .then((up) => {
      if (!up) {
        store.dispatch(setMaintenance(true));
      }
    })
    .finally(() => {
      confirming = null;
    });
};
